const defaultOptions = {
    force: false,
    timeoutMS: 60000,
    intervalMS: 50,
    scriptNames: [
        'sales-sdk',
        'terminal',
    ],
    isChrome: () => /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
    isWS: () => window.external && typeof window.external.InjectWsSalesSdkScript === 'function',
}

/**
 * Injection of Wireless Sales SDK.
 * @memberof posPlatform.wireless
 * @function inject
 * @param  {Object} [options=defaultOptions] The inject options.
 * @param  {boolean} [options.force=false] The force injection argument.
 * Please, observe the wireless wizard beaviour.
 * If there is any situation our app doesn't have access to the wireless API,
 * it means that wizard stopped from automatic injecting a SSDK.
 * Pass this argument as true for this cases.
 * @param  {number} [options.timeoutMS=60000] The timeout after which injection rejected. 
 * @param  {number} [options.intervalMS=50] The inteval for checking, that all scriptNames injected. 
 * @param  {string[]} [options.scriptNames=['sales-sdk','terminal']] The scripts names for resolve injection.
 * @returns {Promise} Promise object represents injection status
 */
export default function inject(env) {
    const {
        force,
        timeoutMS,
        intervalMS,
        scriptNames,
        isChrome,
        isWS,
    } = { ...defaultOptions, ...env };

    return new Promise((resolve, reject) => {
        try {
            //in IE (opposite to the Chrome) script injection is syncrhonous, so we need to introduce some sort of observer
            if (!isChrome()) resolve();
            if (!isWS())
                throw new Error('Missed window.external.InjectWsSalesSdkScript');

            let interval = setInterval(() => {
                if (
                    !Array.isArray(window.WS_Injected_Scripts) ||
                    !scriptNames.every(
                        name => window.WS_Injected_Scripts.includes(name))
                ) return;

                resolve(window.WS_Injected_Scripts);
                clearInterval(interval);
            }, intervalMS);
            timeoutMS && setTimeout(() => {
                reject();
                clearInterval(interval);
            }, timeoutMS);

            if (!force) return;

            window.external.InjectTerminalScript();
            window.external.InjectWsSalesSdkScript();
        } catch (err) {
            reject(err);
        }
    });
}
